module.exports = __webpack_public_path__ + "static/media/continue.78f60de5.png";